import PieChartUniGeneral from "./pie-chart-unigeneral";
import PieChartPopularSubs from "./pie-chart-popular-subs";
import HorizontalBarChart from "./horizontal-bar-chart";
import VerticalBarChart from "./vertical-bar-chart";
import PieChartDashboard from "./pie-chart-dashboard";

export default {
  PieChartDashboard,
  PieChartUniGeneral,
  PieChartPopularSubs,
  HorizontalBarChart,
  VerticalBarChart,
};
